module.exports = __webpack_public_path__ + "static/NotoSans-BoldItalic.subset-da663367eba00ace3b75a42d9140fa0c.woff2";